import { SidebarTrigger } from "../ui/sidebar";
import { ModeToggle } from "../shared/modeToggle";

const AdminNavBar = () => {
  return (
    <div className="border-b p-4 justify-between flex items-center">
      <SidebarTrigger />
      <div className="flex items-center gap-4">
        <ModeToggle />
      </div>
    </div>
  );
};

export default AdminNavBar;
